import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectSpread from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { decode as base64url } from '../../runtime/base64url.js';
import verify from '../../runtime/verify.js';
import { JOSEAlgNotAllowed, JWSInvalid, JWSSignatureVerificationFailed } from '../../util/errors.js';
import { concat, encoder, decoder } from '../../lib/buffer_utils.js';
import isDisjoint from '../../lib/is_disjoint.js';
import isObject from '../../lib/is_object.js';
import checkKeyType from '../../lib/check_key_type.js';
import validateCrit from '../../lib/validate_crit.js';
import validateAlgorithms from '../../lib/validate_algorithms.js';
export function flattenedVerify(_x, _x2, _x3) {
  return _flattenedVerify.apply(this, arguments);
}

function _flattenedVerify() {
  _flattenedVerify = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(jws, key, options) {
    var _a, parsedProt, protectedHeader, joseHeader, extensions, b64, alg, algorithms, resolvedKey, data, signature, verified, payload, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isObject(jws)) {
              _context.next = 2;
              break;
            }

            throw new JWSInvalid('Flattened JWS must be an object');

          case 2:
            if (!(jws.protected === undefined && jws.header === undefined)) {
              _context.next = 4;
              break;
            }

            throw new JWSInvalid('Flattened JWS must have either of the "protected" or "header" members');

          case 4:
            if (!(jws.protected !== undefined && typeof jws.protected !== 'string')) {
              _context.next = 6;
              break;
            }

            throw new JWSInvalid('JWS Protected Header incorrect type');

          case 6:
            if (!(jws.payload === undefined)) {
              _context.next = 8;
              break;
            }

            throw new JWSInvalid('JWS Payload missing');

          case 8:
            if (!(typeof jws.signature !== 'string')) {
              _context.next = 10;
              break;
            }

            throw new JWSInvalid('JWS Signature missing or incorrect type');

          case 10:
            if (!(jws.header !== undefined && !isObject(jws.header))) {
              _context.next = 12;
              break;
            }

            throw new JWSInvalid('JWS Unprotected Header incorrect type');

          case 12:
            parsedProt = {};

            if (!jws.protected) {
              _context.next = 22;
              break;
            }

            _context.prev = 14;
            protectedHeader = base64url(jws.protected);
            parsedProt = JSON.parse(decoder.decode(protectedHeader));
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](14);
            throw new JWSInvalid('JWS Protected Header is invalid');

          case 22:
            if (isDisjoint(parsedProt, jws.header)) {
              _context.next = 24;
              break;
            }

            throw new JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');

          case 24:
            joseHeader = _objectSpread({}, parsedProt, jws.header);
            extensions = validateCrit(JWSInvalid, new Map([['b64', true]]), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
            b64 = true;

            if (!extensions.has('b64')) {
              _context.next = 31;
              break;
            }

            b64 = parsedProt.b64;

            if (!(typeof b64 !== 'boolean')) {
              _context.next = 31;
              break;
            }

            throw new JWSInvalid('The "b64" (base64url-encode payload) Header Parameter must be a boolean');

          case 31:
            alg = joseHeader.alg;

            if (!(typeof alg !== 'string' || !alg)) {
              _context.next = 34;
              break;
            }

            throw new JWSInvalid('JWS "alg" (Algorithm) Header Parameter missing or invalid');

          case 34:
            algorithms = options && validateAlgorithms('algorithms', options.algorithms);

            if (!(algorithms && !algorithms.has(alg))) {
              _context.next = 37;
              break;
            }

            throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter not allowed');

          case 37:
            if (!b64) {
              _context.next = 42;
              break;
            }

            if (!(typeof jws.payload !== 'string')) {
              _context.next = 40;
              break;
            }

            throw new JWSInvalid('JWS Payload must be a string');

          case 40:
            _context.next = 44;
            break;

          case 42:
            if (!(typeof jws.payload !== 'string' && !(jws.payload instanceof Uint8Array))) {
              _context.next = 44;
              break;
            }

            throw new JWSInvalid('JWS Payload must be a string or an Uint8Array instance');

          case 44:
            resolvedKey = false;

            if (!(typeof key === 'function')) {
              _context.next = 50;
              break;
            }

            _context.next = 48;
            return key(parsedProt, jws);

          case 48:
            key = _context.sent;
            resolvedKey = true;

          case 50:
            checkKeyType(alg, key, 'verify');
            data = concat(encoder.encode((_a = jws.protected) !== null && _a !== void 0 ? _a : ''), encoder.encode('.'), typeof jws.payload === 'string' ? encoder.encode(jws.payload) : jws.payload);
            signature = base64url(jws.signature);
            _context.next = 55;
            return verify(alg, key, signature, data);

          case 55:
            verified = _context.sent;

            if (verified) {
              _context.next = 58;
              break;
            }

            throw new JWSSignatureVerificationFailed();

          case 58:
            if (b64) {
              payload = base64url(jws.payload);
            } else if (typeof jws.payload === 'string') {
              payload = encoder.encode(jws.payload);
            } else {
              payload = jws.payload;
            }

            result = {
              payload: payload
            };

            if (jws.protected !== undefined) {
              result.protectedHeader = parsedProt;
            }

            if (jws.header !== undefined) {
              result.unprotectedHeader = jws.header;
            }

            if (!resolvedKey) {
              _context.next = 64;
              break;
            }

            return _context.abrupt("return", _objectSpread({}, result, {
              key: key
            }));

          case 64:
            return _context.abrupt("return", result);

          case 65:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[14, 19]]);
  }));
  return _flattenedVerify.apply(this, arguments);
}